import { APPLICATION_SUBMITTED_QUERY } from "@/graphql/application-submitted-query";
import {
  ApplicationSubmittedInterface,
  submittedContent,
} from "@/models/application-submitted/application-submitted.interface";
import gql from "graphql-tag";
import { Component, Vue } from "vue-property-decorator";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import MoreInformationComponent from "../more-information/more-information.component.vue";

@Component({
  name: "application-submitted",
  components: {
    AppLoaderComponent,
    MoreInformationComponent,
  },
})
export default class ApplicationSubmittedComponent extends Vue {
  public applicationSubName: any;
  public applicationId: any;
  public SuccessfulMessage: submittedContent = {} as submittedContent;
  public messageContent = "";
  public showCode = [
    "Certification: Part One",
    "Certification: Part Two",
    "Endorsement Application",
  ];
  public isLoading = true;
  public applicationSubmittedData: ApplicationSubmittedInterface =
    {} as ApplicationSubmittedInterface;

  public async created() {
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("active");
      el.classList.remove("remove-container");
    }
    this.applicationSubName = this.$route.query.subTitle;
    this.applicationId = this.$route.query.applicationId;
    await this.$apollo
      .query({
        query: gql`query ${APPLICATION_SUBMITTED_QUERY}`,
      })
      .then((result) => {
        this.applicationSubmittedData = result;
        const currentApplicationSubmitted =
          this.applicationSubmittedData.data.applicationSubmitteds.data.find(
            (result) => {
              if (result.attributes.form === this.applicationSubName) {
                return result;
              }
            }
          );
        if (currentApplicationSubmitted?.attributes) {
          this.SuccessfulMessage = currentApplicationSubmitted?.attributes;
          this.messageContent =
            currentApplicationSubmitted?.attributes.content.replace(
              /<\/?[^>]+(>|$)/g,
              ""
            );
        }
      })
      .catch(() => {
        // The confirmation text is CMS-driven, but a submission has already
        // succeeded by the time we get here — failing to fetch the wording must
        // not leave the applicant staring at a spinner with no confirmation.
      })
      .finally(() => {
        this.isLoading = false;
        if (!this.messageContent) {
          this.messageContent = this.fallbackMessage;
        }
      });
  }

  // Shown when the CMS has no entry matching this form, or could not be
  // reached. Without it the page renders blank and reads as a failed submit.
  public get fallbackMessage(): string {
    return "Your application has been submitted successfully.";
  }
}
